// Live CRDT sync (Phase 2b) gate. Sync is now the DEFAULT persistence path
// (the /sync endpoint is deployed + verified). Force the legacy REST save path
// — offline / single-writer fallback — with localStorage['codeframe.liveSync']='0'
// or VITE_CODEFRAME_LIVE_SYNC='0'.

function viteEnv(): { VITE_CODEFRAME_LIVE_SYNC?: string; VITE_CODEFRAME_SYNC_URL?: string; VITE_CODEFRAME_PROXY_URL?: string } {
  return (import.meta as unknown as { env?: Record<string, string> }).env ?? {};
}

export function isLiveSyncEnabled(): boolean {
  // Explicit opt-out wins; otherwise sync is on by default.
  if (typeof localStorage !== 'undefined') {
    const v = localStorage.getItem('codeframe.liveSync');
    if (v === '0') return false;
    if (v === '1') return true;
  }
  if (viteEnv().VITE_CODEFRAME_LIVE_SYNC === '0') return false;
  return true;
}

const PROXY_KEY = 'codeframe.proxyUrl';

/** ws(s):// URL of the embedded Hocuspocus endpoint. The `room` is sent by the
 *  provider as the document name, not in the path. */
export function syncUrl(_room: string): string {
  const override = viteEnv().VITE_CODEFRAME_SYNC_URL
    || (typeof localStorage !== 'undefined' ? localStorage.getItem('codeframe.syncUrl') : '') || '';
  if (override) return override;
  const stored = (typeof localStorage !== 'undefined' && localStorage.getItem(PROXY_KEY)) || '';
  const base = (stored || viteEnv().VITE_CODEFRAME_PROXY_URL || 'ws://localhost:8787').split('?')[0]!.replace(/\/+$/, '');
  return `${base}/sync`;
}
